var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notice',{class:_vm.$style.errors__notice,attrs:{"error":"","text":_vm.text,"type":_vm.noticeType}})
}
var staticRenderFns = []

export { render, staticRenderFns }